import get from 'lodash.get';

type Collection = Record<string, any>[];
type EntityIds = string | number | string[] | number[] | undefined;

/**
 * Find all items in a collection that have an entityPath with a match to any of the entityIds.
 * Will result in an array for items that belong to the entity or any of its children.
 */
const filterByEntities = (
    collection: Collection,
    entityIds?: EntityIds
): Collection => {
    if (!Array.isArray(entityIds) || !entityIds.length) {
        return collection;
    }
    return collection.filter((item) => {
        const entityPath = get(item, 'entityPath');

        // Filter out any items that don't have an entityPath
        if (!entityPath) {
            return false;
        }

        // Look for the existence of the entityId anywhere in the entityPath
        return entityIds.some((entityId: any) =>
            `${entityPath}/`.includes(`/${entityId}/`)
        );
    });
};

export default filterByEntities;
